module.exports = __webpack_public_path__ + "media/images/game_icon/th/VG1004-1be36df6ccf43a21468466fb0c8a7f81.png";